import call from './call';
import messageShow from "./messageShow";
import login from "./login";
import {RESET_DOCUMENT} from "../types";

const uploadID= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1])
        {
            if(result[1].success)
                dispatch(login(result[1]));
            else
            {
                dispatch({type:RESET_DOCUMENT});
                dispatch(messageShow({message: result[1].error, type: 'error'}));
            }
        }
    }
    dispatch(call("Service/uploadID",formValues,onResult));
};
export default uploadID;